(() => {
  if (customElements.get('idas-press')) return;

  class IdasPress extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-idas-editor')) return;

      const track = this.querySelector('[data-idas-press-track]');
      const group = this.querySelector('[data-idas-press-group]');
      if (!track || !group || group.children.length === 0) return;

      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
      this.classList.add('is-marquee');
    }
  }

  customElements.define('idas-press', IdasPress);
})();
